export default __webpack_public_path__ + "static/media/IMG_1718 copie.8d486184.jpg";